import { Component } from '@angular/core';

@Component({
  selector: 'allas-unete-ahora',
  imports: [],
  template: `<article
    id="unete-ahora-banner"
    class="text-white pl-2 grid grid-cols-12 relative bg-cover bg-center"
  >
    <!-- Texto -->
    <section
      class="col-span-6 xl:col-span-8 flex flex-col gap-1 xl:gap-4 xl:ml-32 xl:mt-16 pb-4 xl:pb-16"
    >
      <!-- Textos de Club y Logo de Allas -->
      <div
        class="flex items-end justify-between xl:justify-start gap-4 xl:ml-24 mt-6 xl:mt-0"
      >
        <!-- Texto de Exclusivos club y Recompensas -->
        <div class="flex flex-col gap-1 xl:gap-1 self-start">
          <span
            class="text-[6px] xl:text-sm font-light -skew-x-12 bg-red-600 px-2 py-0 xl:py-1 rounded-full w-max"
          >
            Exclusivos Club
          </span>
          <p class="text-[8px] xl:text-3xl font-medium italic ml-2 xl:ml-5">
            RECOMPENSAS
          </p>
        </div>
        <img
          src="/logos/version-white-red.webp"
          alt="Logo de Allas"
          class="h-5 xl:h-14 xl:mt-4 w-auto aspect-[3/1]"
        />
      </div>

      <!-- Texto en Grande de UNETE AHORA, ES GRATIS -->
      <div class="flex flex-col gap-1">
        <span class="text-2xl xl:text-6xl font-bold fs-condensed">
          ÚNETE AHORA, <br class="xl:hidden" />
          ES GRATIS!!!
        </span>
      </div>
      <!-- Linea Divisora -->
      <div class="w-full h-[1px] bg-white hidden xl:block"></div>
      <!-- Texto en Pequeño de Accede a beneficios únicos y descuentos especiales solo para socios. -->
      <p
        class="text-[10px] xl:text-2xl font-light opacity-70 xl:opacity-100 fs-condensed"
      >
        crea una cuenta digital y une tus cuentas si ya tienes una membresía
        <br class="hidden xl:block" />
        obtenida en una de nuestras tiendas.
      </p>
      <!-- Linea Divisora -->
      <div class="w-full h-[1px] bg-white xl:hidden"></div>
      <!-- Botones de Acción -->
      <div
        class="flex gap-4 mt-6 xl:ml-12 justify-center xl:justify-start items-center xl:items-start"
      >
        <a
          href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
          class="flex items-center justify-center bg-white text-appPrimary-500 hover:scale-105 transition-transform duration-150 ease-in px-3 xl:px-6 py-1 xl:py-2 rounded-md text-[8px] xl:text-lg font-bold xl:font-normal"
        >
          AFILIARME AHORA
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
          class="items-center justify-center border border-white text-white hover:scale-105 transition-transform duration-150 ease-in px-6 py-2 rounded-md text-lg hidden xl:flex"
        >
          DESCARGAR APP
        </a>
        <a
          href="/login"
          class="items-center justify-center border border-white text-white hover:scale-105 transition-transform duration-150 ease-in px-6 py-2 rounded-md text-lg hidden xl:flex"
        >
          INICIAR SESIÓN
        </a>
      </div>
    </section>
  </article> `,
  styles: [
    `
      :host {
        display: block;
      }

      article#unete-ahora-banner {
        background-image: url('/images/services/afiliaciones/banner-unete-ahora-mobile.webp') !important;
        background-size: cover;
        background-position: center;
      }

      @media (min-width: 1280px) {
        article#unete-ahora-banner {
          background-image: url('/images/services/afiliaciones/banner-unete-ahora-desktop.webp') !important;
        }
      }
    `,
  ],
})
export class UneteAhora {}
